export default "__VITE_ASSET__Cy2IcdWM__"